import { ASSETS_URI } from "../../config";

const EmbedCard = ({ item }) => {
    return (
        <div
            className="column column-3 column-6"
            key={item.pdfID}
        >
            <div
                className="pdf-item"
            >
                <div className="cover-img">
                    <img src={`${ASSETS_URI}/${item.coverImage}`} alt={item.titleName} />
                </div>
                <div className="pdf-title">
                    <h2>{item.titleName}</h2>
                </div>
            </div>
        </div>
    )
}

export default EmbedCard